<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from './components/AppHeader.vue'
import ContextNavigation from './components/ContextNavigation.vue'
import FontLibraryPanel from './components/FontLibraryPanel.vue'
import MusicLibraryPanel from './components/MusicLibraryPanel.vue'
import { initializeFontLibrary } from './font'
import { syncMusicAccount } from './music'
import { standaloneMode } from './api'
import { auth } from './state'
import brandLogo from './assets/brand/logo-lumiscale-final.svg'

const route = useRoute()
const immersive = computed(() => Boolean(route.meta.immersive))
const workspace = computed(() => ['creator-new', 'creator-edit', 'local-creator-new', 'local-creator-edit'].includes(String(route.name)))
void initializeFontLibrary()
watch(() => auth.user?.id, () => syncMusicAccount(), { immediate: true })
</script>

<template>
  <div :class="['app-shell', { 'workspace-shell': workspace }]">
    <AppHeader v-if="!immersive" />
    <ContextNavigation v-else compact immersive />
    <FontLibraryPanel />
    <MusicLibraryPanel />
    <main :class="{ 'immersive-main': immersive }">
      <RouterView v-slot="{ Component }">
        <Transition name="page" mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </main>
    <footer v-if="!immersive && !workspace" class="site-footer">
      <RouterLink class="footer-brand" to="/" aria-label="返回心光量域首页">
        <img class="footer-logo" :src="brandLogo" alt="" width="48" height="39">
        <span><strong>心光量域</strong><small>LUMISCALE</small></span>
      </RouterLink>
      <p>个人非经营性问卷展示与自我探索工具，不提供医学诊断、付费服务或开放社区互动。</p>
      <div class="footer-links">
        <RouterLink to="/explore">浏览内容馆</RouterLink>
        <RouterLink v-if="auth.user && !standaloneMode" to="/account">管理员安全设置</RouterLink>
        <RouterLink v-else :to="standaloneMode ? '/creator' : '/local-create'">本地创作</RouterLink>
        <a class="footer-icp" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">宁ICP备2026002872号-1</a>
        <a
          class="footer-icp footer-public-security"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=64040202110100"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="公安联网备案：宁公网安备64040202110100号（在新窗口查询）"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8 19 6v5.3c0 4.5-2.9 8.5-7 9.9-4.1-1.4-7-5.4-7-9.9V6l7-3.2Z"/><path d="m8.7 12 2.1 2.1 4.7-4.7"/></svg>
          <span>宁公网安备64040202110100号</span>
        </a>
        <span>© 2026</span>
      </div>
    </footer>
  </div>
</template>
